import React, { useState, useEffect, useRef } from "react";
import BrandLogo from "../../Common/BrandLogo";

interface BootProps {
  onDone: () => void;
}

export default function Boot({ onDone }: BootProps) {
  const [pct, setPct] = useState(0);
  const barRef = useRef<HTMLElement>(null);
  const lines = [
    "▸ LINK · BASE SEPOLIA ……… OK",
    "▸ FETCH · NASA / IAU / USGS … OK",
    "▸ INDEX · 10,841 REGIONS …… OK",
    "▸ CALIBRATE TELESCOPES ……… OK",
  ];
  useEffect(() => {
    let p = 0;
    const id = setInterval(() => {
      p = Math.min(100, p + Math.random() * 16 + 6);
      setPct(Math.round(p));
      if (p >= 100) {
        clearInterval(id);
        setTimeout(onDone, 480);
      }
    }, 150);
    return () => clearInterval(id);
  }, []);
  return (
    <div id="boot">
      <div className="boot-logo">
        <BrandLogo size={56} />
      </div>
      <div className="boot-mark">
        Nifty<b>Sky</b>
      </div>
      <div className="boot-status">Calibrating telescopes…</div>
      <div className="boot-bar">
        <i ref={barRef} style={{ width: pct + "%" }}></i>
      </div>
      <div className="boot-pct tnum">{String(pct).padStart(3, "0")}%</div>
      <div className="boot-lines">
        {lines.map((l, i) => (
          <span
            key={i}
            style={{ opacity: pct > i * 25 ? 1 : 0, transition: "opacity .3s" }}
          >
            {l}
          </span>
        ))}
      </div>
    </div>
  );
}
